export default __webpack_public_path__ + "static/media/Collection_White.0dbf6334.svg";